<div class="full-height layout-row layout-align-start-center">
  <app-bringoz-package-item-icon *ngIf="!nameOnly"
                                 class="margin-right-5"
                                 [icon]="item.icon || icon"
                                 [isMissingPackage]="isMissingPackage"
                                 [packingDisplayStatus]="packingDisplayStatus"></app-bringoz-package-item-icon>

  <span class="br-body-2 text-ellipsis">{{item.name || name}}</span>
  <span *ngIf="!!count" class="br-body-2 text-ellipsis margin-left-5">X{{count}}</span>
</div>
